import { parseNumUri } from "num-client";

export const getNumIdFromNumUriString = numUriString => {
  if (!numUriString) return;
  const { host, userinfo } = parseNumUri(numUriString);
  const userPart = userinfo?.s ? `${userinfo?.s}@` : "";
  const hostPart = host?.s || "";
  return `${userPart}${hostPart}`;
};

export const formatNumUriString = numUriString => {
  if (!numUriString) return;
  const { path } = parseNumUri(numUriString);
  const pathPart = path?.s !== "/" ? path?.s : "";
  return `${getNumIdFromNumUriString(numUriString)}${pathPart}`;
};

export const chooseImage = images => {
  return images?.[0]?.variants?.[0]?.url;
};

export const responseSuccessful = response => {
  if (response?.status) {
    return response.status >= 200 && response.status < 300;
  } else {
    return null;
  }
};
